import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { ListDisplayType } from '@/components/ListSwitcher/types';

/** 卡片视图全局状态接口 */
export interface CardViewState {
  /** 全局视图模式（所有页面共享） */
  displayType: ListDisplayType;
  /** BgInfo 全局展开偏好 */
  bgInfoExpanded: boolean;

  /** 设置全局视图模式 */
  setDisplayType: (displayType: ListDisplayType) => void;
  /** 设置 BgInfo 全局展开偏好 */
  setBgInfoExpanded: (expanded: boolean) => void;
  /** 切换 BgInfo 全局展开偏好 */
  toggleBgInfoExpanded: () => void;
}

/** localStorage 持久化 key */
const STORAGE_KEY = 'stack-console-card-view-state';

export const useCardViewStore = create<CardViewState>()(
  persist(
    (set) => ({
      displayType: 'table',
      bgInfoExpanded: false,

      setDisplayType: (displayType) => {
        set({ displayType });
      },

      setBgInfoExpanded: (expanded) => {
        set({ bgInfoExpanded: expanded });
      },

      toggleBgInfoExpanded: () => {
        set((state) => ({ bgInfoExpanded: !state.bgInfoExpanded }));
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        displayType: state.displayType,
        bgInfoExpanded: state.bgInfoExpanded,
      }),
    },
  ),
);
